import { createSlice } from "@reduxjs/toolkit";

export interface FeedbackState {
  isOpen: boolean;
}

const initialState: FeedbackState = {
  isOpen: false,
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    openFeedback: (state) => {
      state.isOpen = true;
    },
    closeFeedback: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openFeedback, closeFeedback } = feedbackSlice.actions;

export function selectIsFeedbackOpen(state: { feedback: FeedbackState }) {
  return state.feedback.isOpen;
}
